__turbopack_context__.v({
  "className": "space_grotesk_3fc8433f-module__clatVG__className",
  "variable": "space_grotesk_3fc8433f-module__clatVG__variable",
});
